<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'wallet'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('common.moneywithdraw')}}</h1>
						</div>
						<div class="add-product-wrapper wallet-grid-wrapper">
							<div class="product-container">
								<div class="a-img-blcok">
									<img src="../../assets/images/gift.png" class="d-icon" />
								</div>
								<div class="a-num">${{storeDetail.unreleasedMoney}}</div>
								<div class="a-txt">{{$t('common.pendingbalance')}}</div>
							</div>
							<!-- 冻结金额卡片 -->
							<div class="product-container" v-if="storeDetail.status === '5'"
								style="background: #F0F6FF">
								<div class="a-img-blcok">
									<img src="../../assets/images/gift.png" class="d-icon" />
								</div>
								<div class="a-num">${{ storeDetail.freezeMoney }}</div>
								<div class="a-txt">{{$t('common.frozenamount')}}</div>
							</div>
							<div class="product-container" style="background: #F0F6FF">
								<div class="a-img-blcok">
									<img src="../../assets/images/gift.png" class="d-icon" />
								</div>
								<div class="a-num">${{ storeDetail.money }}</div>
								<div class="a-txt">{{$t('common.walletmoney')}}</div>
							</div>
							<div class="add-inner" @click="openCash()" style="background: #E1EFEA">
								<div>
									<div class="a-img-blcok">
										<img src="../../assets/images/add_product.png" class="d-icon" />
									</div>
									<div class="a-txt">{{$t('common.sendwithdrawrequest')}}</div>
								</div>
							</div>

							<div class="add-inner" @click="openPay()">
								<div>
									<div class="a-img-blcok">
										<img src="../../assets/images/add_product.png" class="d-icon" />
									</div>
									<div class="a-txt">{{$t('common.offlinerechargewalle')}}</div>
								</div>
							</div>
						</div>

						<div class="withdraw-history-container">
							<!-- 标题 提款请求历史记录-->
							<h2 class="fs-18 mb-20">{{$t('common.withdrawrequesthistory')}}</h2>

							<!-- 表格 -->
							<div class="table-responsive">
								<table class="withdraw-table">
									<thead>
										<tr>
											<th>#</th>
											<th>{{$t('table.date')}}</th>
											<th>{{$t('table.amount')}}</th>
											<th>{{$t('table.type')}}</th>
											<th>{{$t('table.status')}}</th>
											<th>{{$t('table.withdrawtype')}}</th>
											<th>{{$t('table.remark')}}</th>
											<th>{{$t('notice.message')}}</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in cashList" :key="index" class="table-row">
											<td>{{ index + 1 }}</td>
											<td>{{ item.createTime }}</td>
											<td>${{ item.cashMoney }}</td>
											<td>{{$t('table.userbalance')}}</td>
											<td>
												<span :class="['status-tag', getStatus01Class(item.status)]">
													{{ getApproval01Text(item.status) }}
												</span>
											</td>
											<td>USDT</td>
											<td>{{ item.remark }}</td>
											<td>{{ item.storeMemberRemark }}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<template v-if="cashList.length > 0">
								<div class="table-mobile-wrapper">
									<div class="order-item-wrapper" v-for="(item, index) in cashList" :key="index"
										@click="openPage('order-infos')">
										<div class="order-item-header">
											<div class="order-no"># {{ index + 1 }}</div>
											<span class="o-sta-txt">
												<span :class="['status-tag', getStatus01Class(item.status)]">
													{{ getApproval01Text(item.status) }}
												</span>
											</span>
										</div>
										<div class="order-item-inner">
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.date')}}:</div>
												<div class="o-item-value"> {{ item.createTime }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.amount')}}:</div>
												<div class="o-item-value o-price">${{ item.cashMoney }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.type')}}:</div>
												<div class="o-item-value">{{$t('table.userbalance')}}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.withdrawtype')}}:</div>
												<div class="o-item-value ">USDT</div>
											</div>

											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.remark')}}:</div>
												<div class="o-item-value">{{ item.remark }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('notice.message')}}:</div>
												<div class="o-item-value">{{ item.storeMemberRemark }}</div>
											</div>
										</div>
									</div>
								</div>

								<!-- 分页 -->
								<div class="pagination-container d-flex">
									<el-pagination background :page-count="isMobile ? 4 : 10"
										layout="prev, pager, next" :total="cashTotal"
										:current-page.sync="cashParams.pageNum" @current-change="getCashList">
									</el-pagination>
								</div>
							</template>
							<template v-else>
								<div class="table-mobile-wrapper">
									<empty></empty>
								</div>
							</template>


						</div>

						<div class="withdraw-history-container" style="margin-top: 20px;">
							<!-- 标题 钱包充值历史记录-->
							<h2 class="fs-18 mb-20">{{$t('common.walletrechargehistory')}}</h2>
							<!-- 表格 -->
							<div class="table-responsive">
								<table class="withdraw-table">
									<thead>
										<tr>
											<th>#</th>
											<th>{{$t('table.amount')}}</th>
											<th>{{$t('table.paymentmethod')}}</th>
											<th>{{$t('table.paymentdetails')}}</th>
											<th>{{$t('table.approval')}}</th>
											<th>{{$t('table.offlinepayment')}}</th>
											<th>{{$t('table.type')}}</th>
											<th>{{$t('table.date')}}</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in payList" :key="index" class="table-row">
											<td>{{ index + 1 }}</td>
											<td>${{ item.payMoney }}</td>
											<td>USDT</td>
											<td>{{ item.remark || '-' }}</td>
											<td>
												<span :class="['status-tag', getStatusClass(item.payStatus)]">
													{{ getApprovalText(item.payStatus) }}
												</span>
											</td>

											<td>{{$t('table.yes')}}</td>
											<td>{{$t('table.userbalance')}}</td>
											<td>{{ item.createTime }}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<template v-if="payList.length > 0">
								<div class="table-mobile-wrapper">
									<div class="order-item-wrapper" v-for="(item, index) in payList" :key="index"
										@click="openPage('order-infos')">
										<div class="order-item-header">
											<div class="order-no"># {{ index + 1 }}</div>
											<span class="o-sta-txt">
												<span :class="['status-tag', getStatusClass(item.payStatus)]">
													{{ getApprovalText(item.payStatus) }}
												</span>
											</span>
										</div>
										<div class="order-item-inner">
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.amount')}}:</div>
												<div class="o-item-value o-price"> ${{ item.payMoney }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.paymentmethod')}}:</div>
												<div class="o-item-value ">USDT</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.paymentdetails')}}:</div>
												<div class="o-item-value">{{ item.remark || '-' }}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.offlinepayment')}}:</div>
												<div class="o-item-value ">{{$t('table.yes')}}</div>
											</div>

											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.type')}}:</div>
												<div class="o-item-value">{{$t('table.userbalance')}}</div>
											</div>
											<div class="order-item-label">
												<div class="o-item-label">{{$t('table.date')}}:</div>
												<div class="o-item-value">{{ item.createTime }}</div>
											</div>
										</div>
									</div>
								</div>

								<!-- 分页 -->
								<div class="pagination-container">
									<el-pagination background :page-count="isMobile ? 4 : 10"
										layout="prev, pager, next" :total="payTotal"
										:current-page.sync="payParams.pageNum" @current-change="getPayList">
									</el-pagination>
								</div>
							</template>
							<template v-else>
								<div class="table-mobile-wrapper">
									<empty></empty>
								</div>
							</template>

						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹窗组件 -->
		<div v-if="cashModal" class="modal-overlay">
			<div class="modal-container" @click.stop>
				<div class="modal-header">
					<h3>{{$t('common.sendwithdrawrequest')}}</h3>
					<button class="close-button" @click="closeCash">&times;</button>
				</div>
				<div class="modal-body">
					<!-- 余额提示 -->
					<div class="balance-info">
						{{$t('common.yourwalletbalance')}}: ${{ storeDetail.money || 0 }}
					</div>
					<!-- 金额 -->
					<div class="form-group">
						<label for="amount">{{$t('table.amount')}}</label>
						<input type="number" v-model="cashForm.cashMoney" :placeholder="$t('tips.enteramount')" />
					</div>

					<!-- 操作类型 -->
					<div class="form-group">
						<label for="oeraType">{{$t('form.oeratype')}}</label>
						<select id="oeraType" v-model="cashForm.type">
							<option value="userBalance">{{$t('table.userbalance')}}</option>
						</select>
					</div>

					<!-- 提现类型 -->
					<div class="form-group">
						<label for="withdrawType">{{$t('table.withdrawtype')}}</label>
						<select id="withdrawType" v-model="cashForm.withdrawType">
							<option value="USDT">USDT</option>
						</select>
					</div>

					<!-- 密码 -->
					<div class="form-group">
						<label for="password">{{$t('form.paypassword')}}</label>
						<input type="password" id="password" v-model="cashForm.payPassword"
							:placeholder="$t('menu.transactionpassword')" />
					</div>

					<!-- 消息 -->
					<div class="form-group">
						<label for="message">Message</label>
						<textarea id="message" v-model="cashForm.remark" :placeholder="$t('form.typeyourmessage')"
							rows="4"></textarea>
					</div>

					<!-- 按钮 -->
					<div class="form-actions">
						<button type="button" class="cancel-btn" @click="closeCash">{{$t('button.cancel')}}</button>
						<button type="button" class="submit-btn" @click="handleCash">{{$t('button.send')}}</button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="payModal" class="modal-overlay">
			<div class="modal-container">
				<div class="modal-header">
					<h3>{{$t('common.offlinerechargewallet')}}</h3>
					<button class="close-button" @click="closePay">&times;</button>
				</div>
				<div class="modal-body">
					<!-- 添加 tab 栏 -->
					<div class="tab-navigation">
						<div class="tab-item" :class="{ active: activeTab === '1' }" @click="activeTab = '1'">
							{{$t('common.usdtrecharge')}}
						</div>
						<div class="tab-item" :class="{ active: activeTab === '2' }" @click="activeTab = '2'">
							{{$t('common.localtransferrecharge')}}
						</div>
						<div class="tab-item" :class="{ active: activeTab === '3' }" @click="activeTab = '3'">
							{{$t('common.swiftinternationaltransfer')}}
						</div>
					</div>

					<!-- 币种选择 -->
					<div class="currency-selection" v-if="activeTab === '1'">
						<div class="chain-selection">
							<div class="chain-option" :class="{active: payForm.chainCategory === item.chainCategory}"
								@click="selectChain(item)" v-for="item in channelList">
								<div class="chain-icon">
									<img :src="chainIcons[item.chainCategory]" />
								</div>
								<span>{{ item.chainCategory==2?'USDT-TRC20':'USDT-ERC20' }}</span>
							</div>

						</div>
						<!-- 钱包地址 -->
            <div class="address-block">
              <!--钱包地址-->
              							<div class="address-text">{{ payForm.channelAddress }}</div>
                            <button class="copy-btn" @click="copyAddress">{{$t('button.copy')}}</button>
              <!--客服-->
<!--              <div style="display: flex;justify-content: center;"><button class="copy-btn"  @click="contactService" >{{$t('button.kefu')}}</button></div>-->
            </div>

						<div class="form-group">
							<label for="amount">{{$t('table.amount')}}:</label>
							<input type="number" id="amount" v-model="payForm.payMoney" :placeholder="$t('tips.enteramount')"
								required>
						</div>

						<div class="form-group">
							<label for="remark">{{$t('form.photo')}}:</label>
							<div class="upload-area" style="position: relative;">
								<input
									style="width:100%;height:100%;opacity:0;position: absolute;top:0;left:0;z-index: 2;cursor: pointer;"
									type="file" accept="image/*" @change="onFileChange" />
								<div v-if="!payForm.certificate" class="upload-placeholder">
									<span>+</span>
								</div>
								<img v-else :src="payForm.certificate" alt="Uploaded photo" class="uploaded-img" />
							</div>
						</div>
						<div class="form-actions">
							<button type="button" class="cancel-btn" @click="closePay">{{$t('button.cancel')}}</button>
							<button type="submit" class="submit-btn" @click="handlePay">{{$t('button.confirm')}}</button>
						</div>

					</div>
					<div class="currency-selection" v-if="activeTab === '2'">
            <div class="contact-service-container">
              <div class="chain-content">
                <div class="chain-option1 active" style="margin-top: 50px;">
                  <div class="chain-icon1" style="border-radius: 50px;">
                    <img src="../../assets/images/bank1.png" style="width:200px;">
                  </div>
                  <div style="margin-top: 20px;"><span >{{$t('common.localtransferrecharge')}}</span></div>
                </div>
                <div style="display:flex; justify-content:center; margin: 50px auto;">  <button class="submit-btn" @click="contactService">{{$t('common.getaccount')}}</button></div>
              </div>
            </div>
					</div>
					<div class="currency-selection" v-if="activeTab === '3'">
            <div class="contact-service-container">
              <div class="chain-content">
                <div class="chain-option1 active" style="margin-top: 50px;">
                  <div class="chain-icon1">
                    <img src="../../assets/images/swf.png" />
                  </div>
                  <div style="margin-top: 20px;"><span >{{$t('common.swiftinternationaltransfer')}}</span></div>
                </div>
                <div style="display:flex; justify-content:center; margin: 50px auto;">  <button class="submit-btn" @click="contactService">{{$t('common.getaccount')}}</button></div>
              </div>
            </div>
					</div>
				</div>
			</div>
		</div>

		<tabBar ref="tabBarRef"></tabBar>
	</div>

</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import empty from '../../components/empty.vue'
	import {
		cashList,
		cashAdd
	} from '../../api/cash'
	import {
		payList,
		getChannel,
		addPay,
		getkefu
	} from '../../api/pay'
	import {
		storeDetail,
		intowallet,
		uploadFile
	} from '../../api/home'
	import usdtErc20 from '../../assets/images/USDT-ERC20.png';
	import usdtTrc20 from '../../assets/images/USDT-TRC20.png'
	import {
		addPlanOrder
	} from "@/api/level";
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar,
			empty
		},
		data() {
			return {
        selectedPayment: 'visa',
				activeTab: '1',
				kefuLink: '',
				chainIcons: {
					'2': usdtTrc20,
					'3': usdtErc20
				},
				active: '',
				cashModal: false,
				payModal: false,
				tableLoading: false,
				cashList: [],
				payList: [],
				channelList: [],
				storeDetail: {
          money: '0.00',
          unreleasedMoney: '0.00',
          freezeMoney: '0.00',
          unpurchasedMoney: '0.00',
          status: ''
        },
				cashForm: {
					cashMoney: null,
					type: "userBalance",
					withdrawType: "USDT",
					payPassword: null,
					remark: null
				},
				payForm: {
					payMoney: null,
					certificate: null,
					chainCategory: null,
					channelAddress: null
				},
				cashTotal: 0,
				payTotal: 0,
				pageNo: 1,
				cashParams: {
					pageNum: 1,
					pageSize: 10,
				},
				payParams: {
					pageNum: 1,
					pageSize: 10,
				},
				selectedFile: null,
				isMobile: false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getCashList();
			this.getPayList();
			this.intowallet();
		},
		methods: {
      selectPayment(paymentType) {
        this.selectedPayment = paymentType;
        // 可以在这里添加其他业务逻辑
      },
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			contactService() {
				// 这里添加联系客服的逻辑
				window.open(this.kefuLink, '_blank');

			},
			getApproval01Text(status) {
				const statusMap = {
					'1': this.$t('table.underreview'),
					'2': this.$t('table.completed'),
					'3': this.$t('table.rejected')
				};
				return statusMap[status] || status;
			},

			getStatus01Class(status) {
				const statusMap = {
					'1': this.$t('table.underreview'),
					'2': this.$t('table.completed'),
					'3': this.$t('table.rejected')
				};
				return statusMap[status] || 'default';
			},
			getApprovalText(status) {
				const statusMap = {
					'1': this.$t('table.approved'),
					'2': this.$t('table.underreview'),
					'3': this.$t('table.failedreview'),
					'4': this.$t('table.cancelled')
				};
				return statusMap[status] || status;
			},
			getStatusClass(status) {
				const statusMap = {
					'1': this.$t('table.approved'),
					'2': this.$t('table.underreview'),
					'3': this.$t('table.failedreview'),
					'4': this.$t('table.cancelled')
				};
				return statusMap[status] || 'default';
			},
			intowallet() {
				// 调用 intowallet 接口
				intowallet().then(res => {
					if (res.code == 200) {
						const data = res.data;
						/*this.storeDetail.money = data.money; // 余额
						this.storeDetail.unreleasedMoney = data.unreleasedMoney; // 未释放金额
						this.storeDetail.freezeMoney = data.freezeMoney; // 冻结金额
						this.storeDetail.unpurchasedMoney = data.unpurchasedMoney; // 未采购金额-待处理金额
						this.storeDetail.status = data.status; // 状态*/
            this.$set(this.storeDetail, 'money', data.money || '0.00');
            this.$set(this.storeDetail, 'unreleasedMoney', data.unreleasedMoney || '0.00');
            this.$set(this.storeDetail, 'freezeMoney', data.freezeMoney || '0.00');
            this.$set(this.storeDetail, 'unpurchasedMoney', data.unpurchasedMoney || '0.00');
            this.$set(this.storeDetail, 'status', data.status || '');

						// this.$message.success('钱包信息获取成功');
					} else {
						// this.$message.error('获取钱包信息失败');
					}
				}).catch(err => {
					this.$message.error('error');
				});
			},
			// 切换链类型
			selectChain(chain) {
				this.payForm.chainCategory = chain.chainCategory;
				this.payForm.channelAddress = chain.channelAddress;
			},
			// 处理支付
			handlePay() {
				if (this.payForm.payMoney == null || this.payForm.payMoney == '') {
					this.$message.error(this.$t('tips.requireaount'));
					return false;
				}
				/* if (!this.payForm.certificate || this.payForm.certificate=='') {
				   this.$message.error('Please upload the photo');
				   return false;
				 }*/

				//图片先不处理

				console.log(this.payForm)

				addPay(this.payForm).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tips.paymentrequestsuccessfully'));
						this.closePay();
						this.getPayList();
					} else {
						this.$message.error(res.msg);
					}
				})

			},
			onFileChange(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto()
			},

			// 修改 uploadPhoto 方法
			uploadPhoto() {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile, this.selectedFile.name);
				let file = formData
				uploadFile(file).then(res => {
					if (res.code == 200) {
						// 假设接口返回的文件URL在 res.data.url 中
						this.payForm.certificate = res.url;
						this.$message.success('Image uploaded successfully');
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(res.msg || 'Image upload failed');
				});

			},
			// 复制地址
			copyAddress() {
				navigator.clipboard.writeText(this.payForm.channelAddress).then(() => {
					this.$message.success(this.$t('tips.copysuccess'));
				}).catch(err => {
					this.$message.error(this.$t('tips.copyfail'));
				});
			},
			openPay() {
				this.payModal = true;
				this.payForm.payMoney = null;
				this.payForm.certificate = null;
				this.payForm.chainCategory = null;
				this.payForm.channelAddress = null;

				getChannel().then(res => {
					if (res.code == 200) {
						this.channelList = res.data;
						this.payForm.chainCategory = this.channelList[0].chainCategory;
						this.payForm.channelAddress = this.channelList[0].channelAddress;
					} else {
						return false;
					}
				})
				getkefu().then(res => {
					if (res.code == 200) {
						this.kefuLink = res.data.kefu;
					} else {
						return false;
					}
				})


			},
			closePay() {
				this.payModal = false;
			},
			openCash() {
				this.cashModal = true;
				this.cashForm.cashMoney = null;
				this.cashForm.type = "userBalance"
				this.cashForm.withdrawType = "USDT"
				this.cashForm.payPassword = null
				this.cashForm.remark = null
				storeDetail().then(res => {
					if (res.code == 200) {
						this.storeDetail = res.data;
					} else {
						this.$message.error(res.msg);
						this.cashModal = false;
						return false;
					}
				})
			},
			handleCash() {
				if (this.cashForm.cashMoney == null || this.cashForm.cashMoney == '') {
					this.$message.error(this.$t('tips.requireaount'));
					return false;
				}
				if (!this.cashForm.payPassword || this.cashForm.payPassword == '') {
					this.$message.error(this.$t('tips.requiretransactionpassword'));
					return;
				}
				console.log(this.storeDetail.money)
				console.log(this.cashForm.cashMoney)
				if (parseFloat(this.storeDetail.money) < parseFloat(this.cashForm.cashMoney)) {
					this.$message.error('Insufficient balance');
					return false;
				}
				cashAdd(this.cashForm).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tips.withdrawalrequestsentsuccessfully'));
						this.closeCash();
						this.getCashList();
						this.intowallet();
					} else {
						this.$message.error(res.msg || 'Withdrawal request failed');
					}
				})
			},
			closeCash() {
				this.cashModal = false;
			},
			getPayList() {
				payList(this.payParams).then(res => {
					if (res.code == 200) {
						this.payList = res.rows;
						this.payTotal = res.total;
					} else {
						return false;
					}
				})
			},
			getCashList() {
				cashList(this.cashParams).then(res => {
					if (res.code == 200) {
						this.cashList = res.rows;
						this.cashTotal = res.total;
					} else {
						return false;
					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/wallet.css");
</style>
<style>
	.withdraw-history-container {
		padding: 20px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.withdraw-table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: 20px;
	}

	.withdraw-table th,
	.withdraw-table td {
		padding: 12px 10px;
		text-align: left;
		border-bottom: 1px solid #ebebeb;
	}

	.withdraw-table th {
		background-color: #f8f9fa;
		font-weight: 600;
		color: #333;
	}

	.withdraw-table tr:hover {
		background-color: #f5f7fa;
	}

	.status-tag {
		display: inline-block;
		padding: 4px 8px;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 500;
	}

	.status-tag.paid {
		background-color: #d4edda;
		color: #155724;
	}

	.status-tag.refused {
		background-color: #f8d7da;
		color: #721c24;
	}

	.pagination-container {
		text-align: center;
		margin-top: 20px;
	}

	/* 移动端适配 */
	@media (max-width: 768px) {
		.withdraw-table {
			font-size: 14px;
		}

		.withdraw-table th,
		.withdraw-table td {
			padding: 8px 6px;
		}

		.withdraw-table th {
			font-size: 14px;
		}

		.withdraw-history-container {
			padding: 15px;
		}

		.pagination-container {
			margin-top: 15px;
		}
	}



	/* 弹窗样式 */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		padding: 20px;
	}

	.modal-container {
		background: white;
		border-radius: 8px;
		width: 100%;
		max-width: 500px;
		max-height: 90vh;
		overflow-y: auto;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;
		border-bottom: 1px solid #eee;
	}

	.modal-header h3 {
		margin: 0;
		font-size: 1.25rem;
	}

	.close-button {
		background: none;
		border: none;
		font-size: 1.5rem;
		cursor: pointer;
		color: #999;
	}

	.modal-body {
		padding: 20px;
	}

	.form-group {
		margin-bottom: 15px;
	}

	.form-group label {
		display: block;
		margin-bottom: 5px;
		font-weight: 500;
	}

	.form-group input,
	.form-group select,
	.form-group textarea {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 1rem;
		box-sizing: border-box;
		z-index: 10000;
	}

	.form-group textarea {
		min-height: 80px;
		resize: vertical;
	}

	.form-actions {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		margin-top: 20px;
	}

	.cancel-btn,
	.submit-btn {
		padding: 10px 20px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 1rem;
	}

	.cancel-btn {
		background-color: #f5f5f5;
		color: #333;
	}

	.submit-btn {
		background-color: #409EFF;
		color: white;
	}

	/* 移动端适配 */

	.balance-info {
		background-color: #d4edda;
		color: #155724;
		padding: 12px;
		border-radius: 4px;
		margin-bottom: 15px;
		font-size: 14px;
	}

	@media (max-width: 768px) {
		.modal-overlay {
			padding: 10px;
			align-items: flex-start;
			overflow-y: auto;
		}

		.modal-container {
			max-width: 100%;
			margin: 20px 0;
		}

		.modal-header {
			padding: 15px;
		}

		.modal-body {
			padding: 15px;
		}

		.form-actions {
			flex-direction: column;
		}

		.cancel-btn,
		.submit-btn {
			width: 100%;
		}
	}


	.chain-selection {
		display: flex;
		gap: 10px;
		margin-bottom: 20px;
	}

	.chain-option {
		flex: 1;
		padding: 15px;
		border: 1px solid #ddd;
		border-radius: 8px;
		text-align: center;
		cursor: pointer;
		transition: all 0.2s;
	}

	.chain-option.active {
		border-color: #409eff;
		background-color: #f5f7fa;
	}

  .chain-option1 {
    flex: 1;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
  }

  .chain-option1.active {
    border-color: #409eff;
    background-color: #f5f7fa;
  }

	.chain-icon {
		width: 40px;
		height: 40px;
		margin: 0 auto 8px;
	}

	.chain-icon img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

  .chain-icon1 {
    width: 200px;
    height: 30px;
    margin: 0 auto 8px;
  }

  .chain-icon1 img {
    width: 100px;
    height: 35px;
    object-fit: contain;
  }

	.address-block {
		/*background: #f5f7fa;*/
		padding: 15px;
		border-radius: 8px;
		margin-bottom: 20px;
		position: relative;

    /*background: #f5f7fa;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    position: relative;
    max-width: 150px;
    margin-left: auto;
    margin-right: auto;*/

	}

	.address-text {
		font-family: monospace;
		word-break: break-all;
		margin-bottom: 10px;
	}

	.copy-btn {
		background: #409EFF;
		color: white;
		border: none;
		padding: 15px 15px;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
	}

	.upload-area {
		width: 150px;
		height: 150px;
		border: 2px dashed #ccc;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin-top: 10px;
		overflow: hidden;
	}

	.upload-placeholder {
		font-size: 24px;
		color: #999;
	}

	.uploaded-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 8px;
	}

	.status-tag.approved {
		background-color: #d4edda;
		color: #155724;
	}

	.status-tag.under-review {
		background-color: #fff3cd;
		color: #856404;
	}

	.status-tag.failed-review {
		background-color: #f8d7da;
		color: #721c24;
	}

	.status-tag.cancelled {
		background-color: #f8d7da;
		color: #721c24;
	}

	.status-tag.under-review {
		background-color: #fff3cd;
		color: #856404;
	}

	.status-tag.completed {
		background-color: #d4edda;
		color: #155724;
	}

	.status-tag.rejected {
		background-color: #f8d7da;
		color: #721c24;
	}

	.tab-navigation {
		display: flex;
		margin-bottom: 20px;
		border-bottom: 1px solid #eee;
	}

	.tab-item {
		padding: 12px 20px;
		cursor: pointer;
		border-bottom: 3px solid transparent;
		transition: all 0.3s;
		font-size: 14px;
		font-weight: 500;
		color: #666;
	}

	.tab-item:hover {
		color: #409EFF;
		font-weight: bold;
	}

	.tab-item.active {
		color: #409EFF;
		border-bottom: 2px solid #409EFF;
	}

	.contact-service-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

  .contact-service-btn {
    margin-top: 50px;
    padding: 12px 30px;
    background-color: #409EFF;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .contact-service-btn:hover {
    background-color: #337ecc;
  }

  .button-center {
    display: flex;
    justify-content: center;
    margin: 80px 0;
  }
</style>
